<template>
  <ChartNormal 
  size="12" 
  offset="0" 
  title="Under Warranty" 
  chart="column" 
  chartType="war" 
  :isCity="false" 
  :withDate="true" 
  :withFinancial="false" />
</template>

<script>
import ChartNormal from "../../components/chart/chartNormal";

export default {
  name: "Under Warranty",
  components: {
    ChartNormal,
  }
};
</script>

